import { EmployeeEventsResponse } from '@/app/models/Shared';
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.primary.main,
}));

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  padding: theme.spacing(1),
}));

type EmployeeEventsGridParams = {
  rows: EmployeeEventsResponse[];
};

const formatter = new Intl.NumberFormat('pt-BR');
const formatterMonetaryValue = (value: any) => `${formatter.format(value)}`;

function EmployeeEventsTable(params: EmployeeEventsGridParams) {
  const { t } = useTranslation('employeeEvents');

  const { rows } = params;
  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell>{t('badge')}</HeaderTableCell>
            <HeaderTableCell>{t('value')}</HeaderTableCell>
            <HeaderTableCell>{t('event.group')}</HeaderTableCell>
            <HeaderTableCell align="center">{t('event.code')}</HeaderTableCell>
            <HeaderTableCell />
            <HeaderTableCell />
            <HeaderTableCell />
          </TableRow>
        </TableHead>
      </Table>
      <Table sx={{ tableLayout: 'fixed' }}>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.badge}>
              <RowTableCell>{row.badge}</RowTableCell>
              <RowTableCell>{`R$ ${formatterMonetaryValue(row.value)}`}</RowTableCell>
              <RowTableCell>{row.group}</RowTableCell>
              <RowTableCell align="center">{row.expenseCode}</RowTableCell>
              <RowTableCell />
              <RowTableCell />
              <RowTableCell />
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <RowTableCell sx={{ textAlign: 'center' }} colSpan={4}>
                <Typography variant="subtitle2">{t('select.the.employee.badge')}</Typography>
              </RowTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default EmployeeEventsTable;
